export const CHICRUITING_LANDING_PATH = "/chicruiting/company/mypage";

export const URL_MAP = {
  SIGNUP_INTEGRATED: "/signup/integrated",
  SIGNUP_STEP0: "/signup/step0",
  SIGNUP_STEP1: "/signup/step1",
  SIGNUP_STEP2: "/signup/step2",
  PHONE_VERIFY: "/phoneVerify",
  POST: "/post",
  POST_WRITE: "/post/write/:board",
  POST_MODIFY: "/post/modify/:bid",
  POST_ARTICLE: "/post/article/:bid",
  QNA: "/qna/:tab",
  QNA_RANKING: "/qna/ranking",
  QNA_ARTICLE: "/qna/article/:bid",
  QNA_WRITE: "/qna/write/:tab",
  QNA_MODIFY: "/qna/modify/:tab/:bid",
};

// Constants
export const CLASS_ROUTE = "class";
export const EDU_ROUTE = "edu";
export const CHANNEL_ROUTE = "channel";
